import { Reference } from "@apollo/client";

import useMutationWithValidation from "@hooks/useMutationWithValidation";
import {
  InternalNoteCreateDocument,
  InternalNoteCreateMutation,
  InternalNoteCreateMutationVariables,
  InternalNoteFragmentDoc
} from "@typing/Generated";

type Args = {
  consultId?: string | null;
  journeyId: string;
};

const useCreateInternalNote = ({ journeyId }: Args) => {
  const [createInternalNote] = useMutationWithValidation<
    InternalNoteCreateMutation,
    InternalNoteCreateMutationVariables
  >(InternalNoteCreateDocument, "internalNote", {
    update: (store, { data }) => {
      if (data?.internalNoteCreate?.internalNote) {
        //
        // We have to add it to the journey's list of internal notes
        //
        try {
          store.modify({
            fields: {
              internalNotes(cachedInternalNoteRefs: readonly Reference[]) {
                const newInternalNote = store.writeFragment({
                  data: data.internalNoteCreate?.internalNote,
                  fragment: InternalNoteFragmentDoc,
                  fragmentName: "InternalNote"
                });
                if (newInternalNote && data.internalNoteCreate?.internalNote) {
                  return [...cachedInternalNoteRefs, newInternalNote];
                }
                return [...cachedInternalNoteRefs];
              }
            },
            id: store.identify({ __typename: "Journey", id: journeyId })
          });
        } catch {
          // The query will raise an error if we haven't asked for the journey's internal notes
        }
      }
    }
  });
  return createInternalNote;
};

export default useCreateInternalNote;
